module.exports = __webpack_public_path__ + "static/media/bonusSpins_100_250.8eefa4ab.png";